import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import sanitize from 'sanitize-filename';
import Spinner from '../UI/Spinner';
import { exportPrint } from '../../actions/versionActions';
import {
  CANVAS_ID_PAGE_1,
  CANVAS_ID_PAGE_2,
  CANVAS_A4_WIDTH,
  CANVAS_A4_HEIGHT,
  CANVAS_LETTER_WIDTH,
  CANVAS_LETTER_HEIGHT,
} from '../../constants/print-export';


const fadeAnimation = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

const Container = styled.div`
animation: ${fadeAnimation} 0.25s;
position: fixed;
left: 0;
right: 0;
top: 0;
bottom: 0;
display: flex;
align-content: center;
justify-content: center;
align-items: center;
z-index: 999999999;
background-color: #000000ca;
`;

const Main = styled.div`
display: ${props => props.isHidden ? 'none' : 'flex'};
flex-direction: column;
align-content: center;
`;

const CanvasContainer = styled.div`
display: flex;
max-width: 900px;
max-height: 600px;
padding: 10px;
margin-bottom: 60px;
gap: 10px;
`;

const CanvasItemContainer = styled.div`
display: flex;
align-items: center;
flex-direction: column;
`;

const Canvas = styled.canvas`
max-width: 100%;
max-height: 100%;
box-shadow: 2px 4px 10px #0000002f;
`;

const Controls = styled.div`
display: flex;
`;

const CloseButton = styled.button`
font-family: 'Dumbledor';
color: var(--botc-colour-cream-springwood);
border: none;
flex: 1 0 0;
font-size: 15px;
background-color: var(--botc-colour-purple);
height: 40px;
padding: 0 20px;
`;

const DownloadButton = styled.button`
font-family: 'Dumbledor';
color: var(--botc-colour-cream-springwood);
border: none;
flex: 1 0 0;
font-size: 15px;
border: solid 1px var(--botc-colour-cream-springwood);
background-color: transparent;
height: 40px;
padding: 10px 20px;
margin-top: 10px;
text-shadow: 1px 1px 6px #00000094;
`;

class PrintExport extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    exportPrint(this.props.scriptName, true, this.props.isLetterExportFormat, this.props.scriptAuthor, this.props.isImageFormat);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.isImageFormat && prevProps.isExporting && !this.props.isExporting) {
      this.props.handleCloseClick();
    }
  }

  render() {
    const canvasWidth = this.props.isLetterExportFormat ? CANVAS_LETTER_WIDTH : CANVAS_A4_WIDTH;
    const canvasHeight = this.props.isLetterExportFormat ? CANVAS_LETTER_HEIGHT : CANVAS_A4_HEIGHT;

    return (
      <Container>
        {this.props.isExporting && <Spinner />}

        <Main isHidden={this.props.isExporting || !this.props.isImageFormat}>
          <CanvasContainer>
            <CanvasItemContainer>
              <Canvas id={CANVAS_ID_PAGE_1} width={canvasWidth} height={canvasHeight}></Canvas>
              <a id="download1" download={this.props.scriptName ? sanitize(this.props.scriptName) + '-1.png' : 'clocktower-custom-1.png'}>
                <DownloadButton type="button" onClick={() => {
                  var download = document.getElementById('download1');
                  var image = document.getElementById(CANVAS_ID_PAGE_1).toDataURL('image/png').replace('image/png', 'image/octet-stream');
                  download.setAttribute('href', image);
                }}>Download</DownloadButton>
              </a>
            </CanvasItemContainer>
            <CanvasItemContainer>
              <Canvas id={CANVAS_ID_PAGE_2} width={canvasWidth} height={canvasHeight}></Canvas>
              <a id="download2" download={this.props.scriptName ? sanitize(this.props.scriptName) + '-2.png' : 'clocktower-custom-2.png'}>
                <DownloadButton type="button" onClick={() => {
                  var download = document.getElementById('download2');
                  var image = document.getElementById(CANVAS_ID_PAGE_2).toDataURL('image/png').replace('image/png', 'image/octet-stream');
                  download.setAttribute('href', image);
                }}>Download</DownloadButton>
              </a>
            </CanvasItemContainer>
          </CanvasContainer>

          <Controls>
            <CloseButton
              onClick={this.props.handleCloseClick}
              type="button"
            >
              Close
            </CloseButton>
          </Controls>
        </Main>
      </Container>
    );
  }

}

export default PrintExport;
